// import type { Icon } from "lucide-vue-next"; // Error on Icon type
// using string for now as it maps to icon names
import { defineStore } from "pinia";

export type MenuAccent = "emerald" | "cyan" | "violet" | "amber" | "indigo";

export interface Menu {
  icon?: string;
  type?: string;
  title: string;
  badge?: number;
  pageName?: string;
  subMenu?: Menu[];
  ignore?: boolean;
  roles?: string[];
  /** Color de sección (alineado con PageTitle variants) */
  accent?: MenuAccent;
}

export interface MenuState {
  value: Array<Menu | string>;
}

export const useMenuStore = defineStore("menu", {
  state: (): MenuState => ({
    value: [
      {
        title: "menu.section_dashboard",
        type: "divider"
      },
      {
        icon: "GaugeCircle",
        pageName: "dashboard",
        title: "menu.dashboard",
      },
      {
        title: "menu.section_archive",
        type: "divider",
      },
      {
        icon: "FileText",
        pageName: "documents",
        title: "menu.documents",
        accent: "cyan",
        roles: ["ADMIN", "TECNICO", "USER"]
      },
      {
        icon: "List",
        pageName: "document-lists",
        title: "menu.document_lists",
        roles: ["ADMIN", "TECNICO", "USER"]
      },
      {
        icon: "BookKey",
        pageName: "loans",
        title: "menu.loans",
        accent: "emerald",
        roles: ["ADMIN", "TECNICO", "USER"]
      },
      {
        icon: "CalendarDays",
        pageName: "loans-calendar",
        title: "menu.calendar", 
        roles: ["ADMIN", "TECNICO"]
      },
      {
        icon: "Printer",
        pageName: "reproductions",
        title: "menu.reproductions",
        accent: "violet",
        roles: ["ADMIN", "TECNICO", "USER"]
      },
      {
        icon: "BookOpen",
        pageName: "publications",
        title: "menu.publications",
        accent: "amber",
        roles: ["ADMIN", "TECNICO", "USER"]
      },
      {
        title: "menu.section_user_management",
        type: "divider",
        roles: ["ADMIN"]
      },
      {
        icon: "Users",
        title: "menu.users",
        roles: ["ADMIN"],
        subMenu: [
          {
            icon: "User",
            title: "menu.users_list",
            pageName: "users"
          }
        ]
      },
      {
        title: "menu.section_system",
        type: "divider",
        roles: ["ADMIN"]
      },
      {
        icon: "Settings",
        pageName: "system-settings",
        title: "menu.settings",
        roles: ["ADMIN"]
      },
      {
        icon: "Activity",
        pageName: "system-logs",
        title: "menu.system_logs",
        roles: ["ADMIN"]
      },
      {
        icon: "ShieldCheck",
        pageName: "audit",
        title: "menu.audit",
        roles: ["ADMIN"]
      },
      {
        icon: "BarChart3",
        pageName: "statistics",
        title: "menu.statistics",
        roles: ["ADMIN"]
      }
    ],
  }),
});
